/* Stove Knobs 2026 — theme behaviour (vanilla JS, no dependencies) */
(function () {
  'use strict';
  var SK = window.SK || { routes: { cart: '/cart', cartAdd: '/cart/add' }, strings: {}, moneyFormat: '${{amount}}' };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var str = function (k, fb) { return (SK.strings && SK.strings[k]) || fb; };

  /* ---------- money (Shopify money format, cents in) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || SK.moneyFormat || '${{amount}}';
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(rx);
    var val = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': val = fmt(cents, 2); break;
      case 'amount_no_decimals': val = fmt(cents, 0); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': val = fmt(cents, 2, ' ', ','); break;
      default: val = fmt(cents, 2);
    }
    return format.replace(rx, val);
  }
  var stripTags = function (h) { var d = document.createElement('div'); d.innerHTML = h; return d.textContent || ''; };

  /* ---------- toast ---------- */
  var toastEl = $('[data-toast]'), toastTimer;
  function toast(html) {
    if (!toastEl) return;
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3600);
  }
  window.skToast = toast;

  /* ---------- header: mobile menu, search, dropdowns ---------- */
  var menuBtn = $('[data-menu]'), mobileNav = $('[data-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', String(open));
    });
  }
  var searchBtn = $('[data-search-toggle]'), searchPanel = $('[data-search-panel]');
  if (searchBtn && searchPanel) {
    searchBtn.addEventListener('click', function () {
      var open = searchPanel.classList.toggle('is-open');
      searchBtn.setAttribute('aria-expanded', String(open));
      if (open) { var i = $('input[type="search"]', searchPanel); if (i) i.focus(); }
    });
  }
  var drops = $$('[data-nav-dropdown]');
  document.addEventListener('click', function (e) {
    drops.forEach(function (d) { if (d.open && !d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    drops.forEach(function (d) { if (d.open) { d.removeAttribute('open'); $('summary', d).focus(); } });
    if (searchPanel && searchPanel.classList.contains('is-open')) { searchPanel.classList.remove('is-open'); searchBtn.setAttribute('aria-expanded', 'false'); searchBtn.focus(); }
  });

  /* ---------- cart count ---------- */
  function refreshCartCount() {
    return fetch(SK.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; }); return cart; });
  }

  /* ---------- homepage finish selection ---------- */
  $$('[data-finish-section]').forEach(function (sec) {
    var sw = $$('.swatch', sec), img = $('.finish-img', sec);
    sw.forEach(function (b) {
      b.addEventListener('click', function () {
        sw.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        if (img && b.dataset.img) {
          img.style.opacity = 0;
          setTimeout(function () {
            img.onload = function () { img.style.opacity = 1; };
            img.removeAttribute('srcset'); img.removeAttribute('sizes');
            img.src = b.dataset.img; img.alt = b.dataset.alt || b.dataset.finish;
          }, 150);
        }
        var n = $('[data-finish-name]', sec), p = $('[data-finish-price]', sec), l = $('[data-finish-link]', sec);
        if (n) n.textContent = b.dataset.finish;
        if (p) p.innerHTML = b.dataset.price;
        if (l) l.href = b.dataset.href;
      });
    });
  });

  /* ---------- collection: client-side finish fallback + sort ---------- */
  var grid = $('[data-grid]');
  if (grid) {
    var cards = $$('.card', grid), filterBtns = $$('[data-filter]'), current = 'all';
    var countEl = $('[data-count]');
    var apply = function () {
      var n = 0;
      cards.forEach(function (c) { var show = current === 'all' || c.dataset.finish === current; c.hidden = !show; if (show) n++; });
      if (countEl) countEl.textContent = (n === 1 ? str('productCountOne', '1 product') : str('productCount', '[count] products')).replace('[count]', n);
      var e = $('[data-empty]', grid); if (e) e.hidden = n > 0;
    };
    filterBtns.forEach(function (p) {
      p.addEventListener('click', function () {
        var on = p.getAttribute('aria-pressed') === 'true' && p.dataset.filter !== 'all';
        current = on ? 'all' : p.dataset.filter;
        filterBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.filter === current)); });
        apply();
      });
    });
  }
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { var f = sel.form; if (f) f.submit(); });
  });

  /* ---------- product page ---------- */
  $$('[data-pdp]').forEach(function (pdp) {
    var section = pdp.closest('.shopify-section') || document;
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var data; try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var V = data.variants || [], S = data.strings || {};
    var form = $('[data-product-form]', pdp);
    var idInput = $('[data-variant-id]', pdp), qtyIn = $('[data-qty-input]', pdp), addBtn = $('[data-add]', pdp);
    var priceEl = $('[data-price]', pdp), subEl = $('[data-sub]', pdp), errEl = $('[data-error]', pdp);
    var mainImg = $('.gallery__main img', pdp), thumbs = $$('.thumb', pdp);
    var startId = idInput ? parseInt(idInput.value, 10) : 0;
    var start = V.filter(function (v) { return v.id === startId; })[0] || V.filter(function (v) { return v.available; })[0] || V[0];
    var sel = start ? start.options.slice() : [];

    var match = function (opts) { return V.filter(function (v) { return v.options.every(function (x, i) { return opts[i] === x; }); })[0]; };
    var qty = function () { return Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1); };

    function showMedia(id, src, alt) {
      if (!mainImg) return;
      thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
      var t = id ? thumbs.filter(function (x) { return x.dataset.mediaId === String(id); })[0] : null;
      if (t) { t.setAttribute('aria-current', 'true'); src = t.dataset.full; alt = t.dataset.alt; }
      if (!src) return;
      mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes');
      mainImg.src = src; if (alt) mainImg.alt = alt;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaId); }); });

    function render(fromUser) {
      $$('[data-opt]', pdp).forEach(function (b) {
        var i = parseInt(b.dataset.opt, 10);
        b.setAttribute('aria-pressed', String(sel[i] === b.dataset.val));
        var test = sel.slice(); test[i] = b.dataset.val;
        var m = match(test);
        b.classList.toggle('is-out', !m || !m.available);
      });
      $$('[data-opt-value]', pdp).forEach(function (s) { s.textContent = sel[parseInt(s.dataset.optValue, 10)] || ''; });
      var v = match(sel);
      if (errEl && fromUser) errEl.textContent = '';
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = str('unavailable', 'Unavailable'); }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = formatMoney(v.price) + (v.compare > v.price ? ' <s>' + formatMoney(v.compare) + '</s>' : '');
      if (subEl) {
        var qi = data.qtyIndex, text = subEl.dataset.fallback || '';
        if (qi > -1) {
          var other = V.filter(function (x) { return x !== v && x.options.every(function (o, i) { return i === qi || o === v.options[i]; }); })[0];
          var isSet = /set|4|four|pack/i.test(v.options[qi]);
          if (isSet) text = S.set + (other ? ' · ' + (S.singleOther || '').replace('[price]', stripTags(formatMoney(other.price))) : '');
          else text = S.single + (other ? ' · ' + (S.setOther || '').replace('[price]', stripTags(formatMoney(other.price))) : '');
        }
        subEl.textContent = text;
      }
      if (addBtn) {
        if (!v.available) { addBtn.disabled = true; addBtn.textContent = str('soldOut', 'Sold out'); }
        else { addBtn.disabled = false; addBtn.textContent = str('addToCart', 'Add to cart') + ' — ' + stripTags(formatMoney(v.price * qty())); }
      }
      if (fromUser) {
        if (v.media) showMedia(v.media);
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      }
    }

    $$('[data-opt]', pdp).forEach(function (b) {
      b.addEventListener('click', function () { sel[parseInt(b.dataset.opt, 10)] = b.dataset.val; render(true); });
    });
    $$('[data-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () { if (!qtyIn) return; qtyIn.value = Math.max(1, qty() + parseInt(b.dataset.qty, 10)); render(false); });
    });
    if (qtyIn) qtyIn.addEventListener('input', function () { render(false); });

    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = match(sel); if (!v || !v.available) return;
        var label = addBtn.textContent;
        addBtn.disabled = true; addBtn.textContent = str('adding', 'Adding…');
        fetch(SK.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty() }] })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return refreshCartCount(); })
          .then(function () {
            toast(str('added', 'Added to cart') + ' <a href="' + SK.routes.cart + '">' + str('viewCart', 'View cart') + '</a>');
          })
          .catch(function (err) {
            var msg = (err && typeof err.description === 'string' && err.description) || str('error', 'Something went wrong. Please try again.');
            if (errEl) errEl.textContent = msg;
          })
          .then(function () { addBtn.textContent = label; render(false); });
      });
    }
    render(false);
  });

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations][data-url]').forEach(function (el) {
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.card')) { el.innerHTML = fresh.innerHTML; el.hidden = false; }
        else { el.hidden = true; }
      })
      .catch(function () { el.hidden = true; });
  });

  /* ---------- cart page: auto-submit quantity changes ---------- */
  $$('[data-cart-form] [data-cart-qty]').forEach(function (input) {
    var t;
    input.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { input.form.submit(); }, 350); });
  });
})();
